export type DetectedSiteLocale = 'nl_NL' | 'fr_FR' | 'en_US'

export const LOCALE_HOME_PATHS: Record<DetectedSiteLocale, string> = {
  nl_NL: '/',
  fr_FR: '/fr/',
  en_US: '/en/',
}

export const detectLocaleFromLanguageTags = (
  tags: string[]
): DetectedSiteLocale => {
  for (const raw of tags) {
    const lang = String(raw).split(';')[0].trim().toLowerCase()

    if (!lang) continue
    if (lang.startsWith('fr')) return 'fr_FR'
    if (lang.startsWith('nl')) return 'nl_NL'
    if (lang.startsWith('en')) return 'en_US'
  }

  return 'en_US'
}

export const parseAcceptLanguageHeader = (
  header?: string | null
): string[] => {
  if (!header) return []

  return header
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
}

export const detectLocaleFromAcceptLanguage = (
  header?: string | null
): DetectedSiteLocale =>
  detectLocaleFromLanguageTags(parseAcceptLanguageHeader(header))

export const getHomePathForLocale = (locale: string): string =>
  LOCALE_HOME_PATHS[locale as DetectedSiteLocale] ?? '/'
